var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReloadApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1114 4.66675L14.51 5.41208C14.7794 5.91541 14.914 6.16741 14.8247 6.27541C14.736 6.38341 14.4427 6.29608 13.8554 6.12208C13.253 5.9438 12.6282 5.85331 12 5.85341C8.50202 5.85341 5.66669 8.60541 5.66669 12.0001C5.66563 13.0823 5.95825 14.1445 6.51336 15.0734M9.88936 19.3334L9.49069 18.5881C9.22136 18.0841 9.08669 17.8321 9.17602 17.7247C9.26469 17.6167 9.55802 17.7034 10.1454 17.8781C10.732 18.0521 11.3554 18.1461 12.0007 18.1461C15.4987 18.1461 18.334 15.3941 18.334 11.9994C18.335 10.9175 18.0424 9.85552 17.4874 8.92675",
    stroke: "#5E6366",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_1478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReloadApp);
export default __webpack_public_path__ + "static/media/ICON_RELOAD_APP.14405f7fddb22f3d935ee89187936e92.svg";
export { ForwardRef as ReactComponent };